import { useState, useEffect } from "react";

import Auth from "./Auth";

const MasterApp = () => {
  return <Auth />;
};

export default MasterApp;
